export default __webpack_public_path__ + "static/media/email.73728d35.svg";